import { render, staticRenderFns } from "./block-image3.vue?vue&type=template&id=9c8e8e46"
import script from "./block-image3.vue?vue&type=script&lang=js"
export * from "./block-image3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports